<template>

     <!-- Raiz da aplicação Vuetify -->
    <v-app> 

        <!-- Área principal da aplicação -->
        <v-main> 
        
            <!-- Barra preta -->
            <v-toolbar
                color="black"
                dense
                flat
                :style="{
                    'border-top-left-radius': '12px',
                    'border-top-right-radius': '8px',
                    'position': 'fixed',
                    'top': '64px',
                    'left': modoBarraLateral ? '70px' : '260px',
                    'width': modoBarraLateral ? 'calc(100% - 70px)' : 'calc(100% - 260px)',
                    'z-index': '999',
                    'transition': 'left 0.3s ease, width 0.3s ease'
                }"
            >      
                
                <v-toolbar-title class="white--text">Cadastro Tipo Equipamento</v-toolbar-title> 
                <v-spacer />

            </v-toolbar>

            <!-- Conteúdo com espaçamento -->
            <v-container fluid class="pa-4">

                <!-- Card que agrupa elementos do formulário  -->
                <v-card class="pa-4" style="width: 100%; top: 60px">

                    <v-form ref="formTipoEquipamento" v-model="validaTipoEquipamento">
                    
                        <v-row>
                        
                            <v-col cols="12" md="2">
                                <v-text-field 
                                    label="Sigla" 
                                    v-model="dadosTipoEquipamento.sigla"
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>
                            
                            <v-col cols="12" md="10">
                                <v-text-field 
                                    label="Nome Equipamento" 
                                    v-model="dadosTipoEquipamento.nome"
                                    maxlength="255"
                                    :rules="[rules.required]"
                                    v-uppercase
                                />
                            </v-col>
                            
                        </v-row>

                        <v-row>

                            <v-col cols="12" md="6" class="d-flex align-center">
                                <v-switch
                                    :label="dadosTipoEquipamento.automovel ? 'Automóvel' : 'Equipamento'"
                                    :color="dadosTipoEquipamento.automovel ? 'blue' : 'black'"
                                    v-model="dadosTipoEquipamento.automovel"
                                />
                            </v-col>

                            <v-col cols="12" md="6" class="d-flex align-center">
                                <v-switch
                                    :label="dadosTipoEquipamento.ativo ? 'Ativo' : 'Inativo'"
                                    :color="dadosTipoEquipamento.ativo ? 'blue' : 'white'"
                                    v-model="dadosTipoEquipamento.ativo"
                                />
                            </v-col>

                        </v-row>

                    </v-form>

                    <v-card-actions class="flex-wrap">

                        <v-spacer />

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            style="background-color: orange; color: white;"
                            @click="funcaoRetornar()"
                            >
                            <v-icon left>mdi-chevron-left</v-icon>
                            Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            style="background-color: #2196F3; color: white;"
                            @click="validarSalvarTipoEquipamento('salvar')"
                            >
                            <v-icon left color="white">mdi-update</v-icon>
                            Salvar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            outlined
                            style="background-color: white; border: 2px solid orange; color: orange;"
                            @click="validarSalvarTipoEquipamento('salvar-retornar')"
                            >
                            <v-icon left color="orange">mdi-update</v-icon>
                            Salvar e Retornar
                        </v-btn>

                        <v-btn
                            class="ma-2 flex-grow-1 flex-sm-grow-0"
                            outlined
                            style="background-color: white; border: 2px solid #2196F3; color: #2196F3;"
                            @click="validarSalvarTipoEquipamento('salvar-novo')"
                            >
                            <v-icon left color="#2196F3">mdi-autorenew</v-icon>
                            Salvar e Novo
                        </v-btn>

                    </v-card-actions>
                    
                </v-card>

            </v-container>

        </v-main>

    </v-app>

</template>

<script setup>

    /* DEPENDENCIAS E VARIAVEIS COMUNS */
    
    // Importa funcionalidades do Vue
    import { ref, onMounted, onBeforeUnmount } from 'vue'
    
    // Importa axios para chamadas API
    import axios from 'axios'

    // Importa o componente do editor de texto rico
    import '@vueup/vue-quill/dist/vue-quill.snow.css'

    // Importa o event bus
    import { emitter } from '../utils/eventBus'

    // Importa o componente do formulário de erros
    import { useErroStore } from '@/stores/erroStore'

    // Importa o componente do Snackbar
    import { useSnackbarStore } from '@/stores/snackbar'

    // Importa o componente do formulário de login
    import { useLoginStore } from '@/stores/loginStore'

    // Importa useRouter para acessar parâmetros de rota
    import { useRouter } from 'vue-router'

    // Importa useRoute para acessar parâmetros de rota
    import { useRoute } from 'vue-router'

    // Importa o canal de comunicação entre componentes
    import { channel } from '@/utils/channel'

    // Carrega o endereço das ap
    const API_BASE_URL = import.meta.env.VITE_API_URL;

    // Importa a store de erros
    const erroStore = useErroStore()

    // Importa a store do snackbar
    const snackbar = useSnackbarStore()

    // Importa a store de chamados
    const loginStore = useLoginStore()

    // Acessa o ID da empresa via query param
    const router = useRouter();

    // Acessa o ID da empresa via query param
    const route = useRoute(); 
    
    
    /* VARIAVEIS DO FORMULÁRIO */
    
    // Variável para armazenar o ID da empresa (0 para nova empresa)
    const idTipoEquipamentoRecebido = ref(0);

    // Referência do formulário de cadastro de empresa
    const formTipoEquipamento = ref(null)

    // Validação do formulário de ramo de atividade
    const validaTipoEquipamento = ref(false)

    // Estado local para o modo da barra lateral
    const modoBarraLateral = ref(false)

    // Salva o id da empresa
    idTipoEquipamentoRecebido.value = Number(route.query.idTipoEquipamento) || 0;

    // Busca o modo da barra lateral vindo da lista
    modoBarraLateral.value = route.query.modoBarraLateral    

    // Dados do ramo de atividade
    const dadosTipoEquipamento= ref({
        idTipoEquipamento: 0,
        sigla: '',
        nome: '',
        automovel: false,
        ativo: true
    })

    // Regras de validação
    const rules = {
        required: v => !!v || 'Campo obrigatório'
    }

    // Limpa campos do cadastro de empresas
    function limpadadosTipoEquipamento(){

        dadosEmpresa.value = {
            idTipoEquipamento: 0,
            sigla,
            nome: '',
            automovel: false,
            ativo: true
        } 
        
        // Limpa id de ramo de atividade recebido da lista
        idTipoEquipamentoRecebido.value = 0
    }

    // Função que lê o tamanho da barra no localStorage e aplica na 
    function ajustaBarraPretaTopo(){
        
        if (localStorage.getItem('tamanhoBarraLaterar') == 'true'){
            modoBarraLateral.value = true
        } else{
            modoBarraLateral.value = false
        }
    }

    // Retorna para a lista de empresas
    function funcaoRetornar() {
        channel.postMessage('atualizar-lista')
        window.close()
    }

    // Regra personalizada para validar campos
    async function validarSalvarTipoEquipamento(funcaoRetorno) {
        
        // Valida o formulário de empresa
        const isValid = await formTipoEquipamento.value?.validate()

        // Se o formulário for válido chama a função para salvar os dados
        if (isValid.valid) {

            // Chama a função para salvar os dados da empresa
            salvardadosTipoEquipamento(funcaoRetorno)

        } else {            
            snackbar.trigger('Preencha os campos obrigatórios.', 'error');
        }
    }    

    // Esta função salva ou edita os dados de uma empresa
    async function salvardadosTipoEquipamento(funcaoRetorno) {

        try {
            
            // Busca o ID da empresa para saber se é inclusão ou edição
            const {data: resposta } = await axios.post(`${API_BASE_URL}/administracao/salvaTipoEquipamento/${idTipoEquipamentoRecebido.value}`, dadosTipoEquipamento.value, {
                headers: {
                    'Authorization': `Bearer ${loginStore.token}`
                }
            })

            // Atualiza o idEmpresa com o valor retornado da API
            idTipoEquipamentoRecebido.value = resposta.idTipoEquipamento;

            // Exibe mensagem de sucesso
            snackbar.trigger('Tipo Equipamento Salvo Com Sucesso.', 'success');

            if (funcaoRetorno == 'salvar'){
                return
            } else if (funcaoRetorno == 'salvar-retornar'){
                funcaoRetornar()
            } else {
                limpadadosTipoEquipamento()
            }

        } catch (erro) {
            erroStore.exibirErro(erro)
        }
    } 

    // Carrega os arrayRamosAtividade ao montar o componente
    onMounted(async () => {

        // Listener para mudanças do drawer
        const manipuladorMudancaTamanho = (data) => {

            // Salva valor emitido pelo botão de minimizar/maximizar a barra lateral
            localStorage.setItem('tamanhoBarraLaterar', data)            
            
            // Ajusta barra preta do topo do formulário
            ajustaBarraPretaTopo(data)
        }
    
        // Adiciona listener para mudanças do drawer
        emitter.on('mudancaBarraLateral', manipuladorMudancaTamanho)

        // Ajusta a barra preta do topo do fomulário com o valor do localStorage
        ajustaBarraPretaTopo()

        // Verifica se existe o idEmpresaRecebido para carregar os dados da empresa
        if (idTipoEquipamentoRecebido.value != 0){

            // Carrega os dados da empresa para edição
            try {
                
                // Chama a API para buscar os dados da empresa pelo ID
                const { data: respostaApi } = await axios.get(`${API_BASE_URL}/operacao/carregaTipoEquipamento/${idTipoEquipamentoRecebido.value}`, {
                    headers: {
                        'Authorization': `Bearer ${loginStore.token}`
                    }
                })

                if (respostaApi) {

                    // Atribui os dados retornados da API à variável dadosTipoEquipamento
                    dadosTipoEquipamento.value = respostaApi.data;     
                    
                    // Converte o campo TINYINT(1) ativo para booleano
                    dadosTipoEquipamento.value.ativo = dadosTipoEquipamento.value.ativo == 1 ? true : false;
                    dadosTipoEquipamento.value.automovel = dadosTipoEquipamento.value.automovel == 1 ? true : false;
                }

            } catch (erro) {
                erroStore.exibirErro(erro)
            }
        }
    })

    // Rotina chamada antes de desmontar o componente
    onBeforeUnmount(() => {

        // Limpar listener
        emitter.off('mudancaBarraLateral')
    })
    
    
</script>